import { GridItem } from '@chakra-ui/react';
import { ListRow } from 'components/molecules/ListRow';
import { TextWithTooltip } from 'components/molecules/TextWithTooltip/TextWithTooltip';
import { FC } from 'react';
import { ApiKeyTemplate } from 'types/apiKeyTemplate';

type Props = {
  /** APIキーテンプレート */
  item: ApiKeyTemplate;
  /** 行クリックイベントのハンドラ */
  handleClickRow: () => void;
};

export const ApiKeyTemplateListItem: FC<Props> = ({ item, handleClickRow }) => (
  <ListRow onClick={handleClickRow} templateColumns="1fr">
    <GridItem>
      <TextWithTooltip
        text={item.name}
        textMaxWidth="150px"
        visibleTooltip
        tooltipMaxWidth="150px"
      />
    </GridItem>
  </ListRow>
);
